import styled from "@emotion/styled";

export const CardsContainer = styled.div`
  display: grid;
  grid-row-gap: 20px;
`;
